import { transition } from '@helpers/animate';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { ComponentTheme } from '@helpers/themeEnum';
import { headingStyles, paragraphSmall } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.div `
  --widgetThemeColor: var(--primaryPageThemeColor);
  --widgetThemeColorLight: var(--primaryPageThemeColorLight);
  --widgetThemeColorTint: var(--primaryPageThemeColorTint);

  &[data-widget-theme=${ComponentTheme.Orange}] {
    --widgetThemeColor: ${brand.orange.base};
    --widgetThemeColorLight: ${brand.orange.light};
    --widgetThemeColorTint: ${brand.orange.tint};
  }

  &[data-widget-theme=${ComponentTheme.Green}] {
    --widgetThemeColor: ${brand.green.base};
    --widgetThemeColorLight: ${brand.green.light};
    --widgetThemeColorTint: ${brand.green.tint};
  }

  &[data-widget-theme=${ComponentTheme.Blue}] {
    --widgetThemeColor: ${brand.blue.base};
    --widgetThemeColorLight: ${brand.blue.light};
    --widgetThemeColorTint: ${brand.blue.tint};
  }

  &[data-widget-theme=${ComponentTheme.Yellow}] {
    --widgetThemeColor: ${brand.yellow.base};
    --widgetThemeColorLight: ${brand.yellow.light};
    --widgetThemeColorTint: ${brand.yellow.tint};
  }

  overflow: hidden;
  text-decoration: none;
  display: block;
`;
const Inner = styled.div `
  position: relative;

  [data-has-image='false'] & {
    display: grid;

    @media ${from(Device.Tablet)} {
      grid-template-columns: 47% 1fr;
    }
  }

  @media ${from(Device.Tablet)} {
    display: grid;
    grid-template-columns: 47% 1fr;
  }
`;
const MediaContainer = styled.div `
  @media ${until(Device.Tablet)} {
    display: grid;
    grid-template-columns: 2fr 1fr;
  }
`;
const MediaHolder = styled.div `
  ${imageWrapperPreserveRatio(407, 573, 407, 573)}
  overflow: hidden;
  border-radius: ${fluid(25, 50)};
  background-color: var(--widgetThemeColorLight);
`;
const ImageDesktop = styled.img `
  ${transition('transform')};
  ${imageCoverContainer()}

  @media ${until(Device.Tablet)} {
    display: none;
  }
`;
const ImageMobile = styled.img `
  ${transition('transform')};
  ${imageCoverContainer()}

  @media ${from(Device.Tablet)} {
    display: none;
  }
`;
const ContentArea = styled.div `
  [data-has-image='false'] & {
    @media ${from(Device.Tablet)} {
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
    }
  }
`;
const QuoteIconArea = styled.div `
  margin-bottom: 15px;

  [data-has-image='true'] & {
    display: none;

    @media ${from(Device.Tablet)} {
      display: block;
      transform: translateX(-72px);
    }
  }

  svg {
    display: none;
    height: 63px;
    color: var(--widgetThemeColor);
    opacity: 0.8;

    @media ${from(Device.Tablet)} {
      display: block;
      height: 80px;
    }
  }
`;
const QuoteIconImageArea = styled.div `
  display: block;
  margin-top: 25px;
  transform: translateX(-42px);

  svg {
    height: 63px;
    color: var(--widgetThemeColor);
    opacity: 0.8;
  }

  @media ${from(Device.Tablet)} {
    display: none;
  }
`;
const ContentInner = styled.div `
  padding: ${fluid(25, 35)} 0;
  color: ${brand.black};

  @media ${from(Device.Tablet)} {
    padding: ${fluid(25, 35)} 0 ${fluid(25, 35)} ${fluid(25, 35)};
  }

  [data-has-image='false'] & {
    padding: ${fluid(25, 60)} ${fluid(25, 35)};
  }
`;
const Title = styled.h3 `
  ${paragraphSmall};
  margin-bottom: 15px;

  [data-has-image='false'] & {
    ${fonts.montserrat.medium};
    color: ${brand.fullBlack};
    opacity: 0.5;
  }
`;
const Intro = styled.p `
  ${headingStyles};
  font-size: ${fluid(20, 28)};
  line-height: ${fluid(30, 38)};
  margin-bottom: 15px;
`;
const SupportText = styled.p `
  ${paragraphSmall};
  margin-bottom: 0;
`;
const TestimonialCardStyles = {
    Container,
    ContentArea,
    ContentInner,
    SupportText,
    ImageDesktop,
    ImageMobile,
    Inner,
    Intro,
    MediaContainer,
    MediaHolder,
    QuoteIconArea,
    QuoteIconImageArea,
    Title,
};
export default TestimonialCardStyles;
